import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import './style.scss';

import { getAuthTokenFromStorage } from '../../utils';

const Profile = (props) => {
  const {
    history,
    updateUser,
    user,
    user: {
      date_created: dateCreated,
      email,
      first_name: firstName,
      last_name: lastName,
      street_address: streetAddress,
      is_admin: isAdmin,
    },
  } = props;

  const [isLoading, setIsLoading] = useState(Object.keys(props.user).length === 0);

  const [isEditing, setIsEditing] = useState(false);
  const [fieldsToChange, setFieldsToChange] = useState({});

  useEffect(() => {
    if (!getAuthTokenFromStorage()) history.push('/sign-up');
  }, []);

  useEffect(() => {
    setIsLoading(Object.keys(user).length === 0);
  }, [user]);

  useEffect(() => {
    if (isEditing) {
      setFieldsToChange({
        first_name: user.first_name,
        last_name: user.last_name,
        street_address: user.street_address,
      });
    }
  }, [isEditing, user]);

  const updateFieldsToChange = fieldName => (event) => {
    event.persist();
    setFieldsToChange(fields => ({ ...fields, [fieldName]: event.target.value }));
  };

  const saveChanges = () => {
    updateUser(fieldsToChange);
    setIsEditing(false);
  };

  const discardChanges = () => {
    setIsEditing(false);
  };

  return (
    <div id="profile-content">
      <h1>Your Profile</h1>
      <div id="content-container">
        {isLoading ? (
          <div id="loading-container">
            <p>Loading...</p>
          </div>
        ) : (
          <>
            <div id="info-container">
              <table>
                <tr>
                  <th>First Name</th>
                  <th>
                    {isEditing ? <input value={fieldsToChange.first_name} onChange={updateFieldsToChange('first_name')} /> : firstName}
                  </th>
                </tr>
                <tr>
                  <th>Last Name</th>
                  <th>
                    {isEditing ? <input value={fieldsToChange.last_name} onChange={updateFieldsToChange('last_name')} /> : lastName}
                  </th>
                </tr>
                <tr>
                  <th>Street Address</th>
                  <th>
                    {isEditing ? <input value={fieldsToChange.street_address} onChange={updateFieldsToChange('street_address')} /> : streetAddress}
                  </th>
                </tr>
                <tr>
                  <th>Email</th>
                  <th>{email}</th>
                </tr>
                <tr>
                  <th>Date Account Created</th>
                  <th>{moment(dateCreated).format('MMMM Do YYYY, h:mm a')}</th>
                </tr>
              </table>
            </div>
            <div id="edit-info-container">
              {isEditing ? (
                <div>
                  <button type="button" onClick={saveChanges}>Save Changes</button>
                  <button type="button" onClick={discardChanges}>Discard Changes</button>
                </div>
              ) : (
                <button type="button" onClick={() => setIsEditing(true)}>Edit Profile</button>
              )}
            </div>
            {isAdmin && (
              <div id="admin-portal-link-container">
                <Link id="admin-portal-link" to="/admin">Go To Admin Portal</Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Profile;
